module.exports = __webpack_public_path__ + "img/465865291.4509f451.svg";